<template>
  <div id="app">
    <router-view></router-view>
    <div class="footer" >
                    <router-link to="/home" >
                        <img src="@/assets/images/f1-1.png" alt="">
                        <p>首页</p>
                    </router-link>
                    <router-link to="/kj" >
                        <img src="@/assets/images/fz.png" alt="">
                        <p>礦機</p>
                    </router-link>
                    <router-link to="/tornado" >
                        <img src="@/assets/images/us3.png" alt="">
                        <p>C2C</p>
                    </router-link>
                    <router-link to="/klinepage" >
                        <img src="@/assets/images/f2-1.png" alt="">
                        <p>k綫圖</p>
                    </router-link>
                    <router-link to="/user" >
                        <img src="@/assets/images/f3-1.png" alt="">
                        <p>个人</p>
                    </router-link>
                </div>
  </div>
</template>

<script>


export default {
  name: 'App',
  
}
</script>

<style scoped>

.footer{
  width:100%;
}
</style>
